export default "__VITE_ASSET__4cf04f9c__"